import { loadAsyncComponent } from 'src/components/AsyncComponent';

export const ProjectsPage = loadAsyncComponent(
  () => import(/* webpackChunkName: "ProjectsPage" */ './Container'),
  'page'
);
